export default "__VITE_ASSET__$22G$lEK__"